import { render, staticRenderFns } from "./BaseFormGroupChosen.vue?vue&type=template&id=461ca524"
import script from "./BaseFormGroupChosen.vue?vue&type=script&lang=js"
export * from "./BaseFormGroupChosen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports